import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '../Checkbox/Checkbox';
import Popover from '../Popover/Popover';
import './RememberMe.scss';

/**
 * RememberMe Component for Skip Second Factor
 * Allows the user to enable skip second factor for future authentications on
 * the same device.
 */
class RememberMe extends React.Component {
  /**
   * The allowed properties for the RememberMe component
   * @param {bool} canOptInToSkipSecondFactor whether or not the component should be shown
   * @param {bool} enableSkipSecondFactor whether or not the checkbox is enabled
   *    and therefore the user is opting it to skip second factor
   * @param {function} toggleSkipSecondFactor set a flag whether or not to save the token
   *    which will allow the user to skip the second strong factor in the future
   * @param {string} label the text on the label for the checkbox
   */
  static propTypes = {
    enableSkipSecondFactor: PropTypes.bool,
    toggleSkipSecondFactor: PropTypes.func.isRequired,
    label: PropTypes.string,
  };

  static defaultProps = { label: 'Remember device', };

  handleClick = (event) => {
    this.props.toggleSkipSecondFactor(event.target.checked);
  };

  render() {
    const help = require('./help.svg');

    const label = (
      <span>
        { this.props.label + ' for ' + this.props.skipSecondFactorPeriod + ' '}
        <Popover
          placement='top'
          trigger={
            <img alt='Help' src={help} width='12px' height='12px' className='help-icon'/>
          }
          triggerType={['focus', 'hover',]}
          body={
            <div className='popover-text'>
            You will not be prompted for a second authentication
            for {this.props.skipSecondFactorPeriod}. Use only for trusted workstations.
            </div>
          }
        />
      </span>);

    return (
      <div className='Remember-Text'>
        { this.props.canOptInToSkipSecondFactor &&
        <div className='text-center'>
          <Checkbox label={label} onClick={this.handleClick}
            checked={this.props.enableSkipSecondFactor}
            defaultChecked={this.props.enableSkipSecondFactor}/>
        </div>
        }
      </div>
    );
  }
}

export default RememberMe;
